import type { PlayerControlSize } from "app/player/controlSizes"

export const RATIO = 16 / 9

/** When the player’s display height is at or below this, control buttons shrink from 48px to 40px. */
export const VIDEO_PLAYER_SHORT_HEIGHT_MAX = 270

/** @deprecated Prefer `PlayerControlSize` from `app/player/controlSizes`. */
export type VideoControlButtonSize = PlayerControlSize

export function isVideoPlayerShortHeight(height: number) {
  return height > 0 && height <= VIDEO_PLAYER_SHORT_HEIGHT_MAX
}
